const theme = {
  colors: {
    primary: "#121212",
    secondary: "#3b82f6"
  }
}

export default theme
